import { useState } from "react";

function useLoader() {
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);

  return { isLoading, setIsLoading, isPageLoading, setIsPageLoading };
}

export default useLoader;
